import React, { Fragment } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { GET_AUTH_DATA } from './graphql/actions/auth.js';
import { GET_ERROR_DATA } from './graphql/actions/error.js';
import 'material-design-icons/iconfont/material-icons.css';
import '@fortawesome/fontawesome-free/css/all.css';
import './assets/css/coscef.css';
import 'typeface-roboto/index.css';

// Pages
import UsuarioLayout from './layouts/UsuarioLayout';
import IndexPage from './pages/IndexPage/IndexPage';
import LoginPage from './pages/AuthPage/LoginPage';
import LogoutPage from './pages/AuthPage/LogoutPage';
import ServicioPage from './pages/ServicioPage/ServicioPage';
import ServicioCrear from './components/ServicioPage/ServicioAdd';
import ServicioEditar from './components/ServicioPage/ServicioEdt';
import EnseñanzaPage from './pages/EnseñanzaPage/EnseñanzaPage';
import EnseñanzaCrear from './components/EnseñanzaPage/EnseñanzaAdd';
import EnseñanzaEditar from './components/EnseñanzaPage/EnseñanzaEdt';
import ArticuloPage from './pages/ArticuloPage/ArticuloPage';
import ArticuloDetails from './components/ArticuloPage/ArticuloDetails';
import ArticuloCrear from './components/ArticuloPage/ArticuloAdd';
import ArticuloEditar from './components/ArticuloPage/ArticuloEdt';
import PonenciaPage from './pages/PonenciaPage/PonenciaPage';
import PonenciaCrear from './components/PonenciaPage/PonenciaAdd';
import PonenciaEditar from './components/PonenciaPage/PonenciaEdt';
import CuentoPage from './pages/CuentoPage/CuentoPage';
import CuentoDetails from './components/CuentoPage/CuentoDetails';
import CuentoCrear from './components/CuentoPage/CuentoAdd';
import CuentoEditar from './components/CuentoPage/CuentoEdt';
import PoesiaPage from './pages/PoesiaPage/PoesiaPage';
import PoesiaDetails from './components/PoesiaPage/PoesiaDetails';
import PoesiaCrear from './components/PoesiaPage/PoesiaAdd';
import PoesiaEditar from './components/PoesiaPage/PoesiaEdt';
import LibroPage from './pages/LibroPage/LibroPage';
import LibroCrear from './components/LibroPage/LibroAdd';
import LibroEditar from './components/LibroPage/LibroEdt';
//import NotFoundPage from './pages/ErrorPage/NotFoundPage';
import NetworkErrorPage from './pages/ErrorPage/NetworkErrorPage';

const App = () => {
  const {
    data: { getErrorData },
  } = useQuery(GET_ERROR_DATA);
  //console.log(getErrorData);

  const {
    data: { getAuthData },
  } = useQuery(GET_AUTH_DATA);

  let routes = (
    <Switch>
      <Route exact path='/administracion' component={LoginPage} />
      <Route exact path='/logout' component={LogoutPage} />
      <UsuarioLayout>
        <Route
          exact
          path='/servicios'
          render={(props) => <ServicioPage {...props} />}
        />
        <Route
          exact
          path='/enseñanzas'
          render={(props) => <EnseñanzaPage {...props} />}
          //component={EnseñanzaPage}
        />
        <Route
          exact
          path='/articulos'
          render={(props) => <ArticuloPage {...props} />}
        />
        <Route
          //exact
          path='/articulo/:id'
          render={(props) => <ArticuloDetails {...props} />}
        />
        <Route
          exact
          path='/ponencias'
          render={(props) => <PonenciaPage {...props} />}
        />
        <Route
          exact
          path='/cuentos'
          render={(props) => <CuentoPage {...props} />}
        />
        <Route
          //exact
          path='/cuento/:id'
          render={(props) => <CuentoDetails {...props} />}
        />
        <Route
          exact
          path='/poesias'
          render={(props) => <PoesiaPage {...props} />}
        />
        <Route
          //exact
          path='/poesía/:id'
          render={(props) => <PoesiaDetails {...props} />}
        />
        <Route
          exact
          path='/libros'
          render={(props) => <LibroPage {...props} />}
        />
        <Route exact path='/' component={IndexPage} />
        <Redirect to='/' />
      </UsuarioLayout>
      {/* <Route exact path='*' component={NotFoundPage} /> */}
    </Switch>
  );

  if (getAuthData) {
    if (getAuthData.isLoggedIn) {
      routes = (
        <Switch>
          <Route exact path='/administracion' component={LoginPage} />
          <Route exact path='/logout' component={LogoutPage} />
          <UsuarioLayout>
            <Route
              exact
              path='/servicios'
              render={(props) => (
                <ServicioPage isAuth={getAuthData.isLoggedIn} {...props} />
              )}
            />
            <Route exact path='/crear-servicio' component={ServicioCrear} />
            <Route
              exact
              path='/editar-servicio/:id'
              component={ServicioEditar}
            />
            <Route
              exact
              path='/enseñanzas'
              render={(props) => (
                <EnseñanzaPage isAuth={getAuthData.isLoggedIn} {...props} />
              )}
              //component={EnseñanzaPage}
            />
            <Route exact path='/crear-enseñanza' component={EnseñanzaCrear} />
            <Route
              exact
              path='/editar-enseñanza/:id'
              component={EnseñanzaEditar}
            />
            <Route
              exact
              path='/articulos'
              render={(props) => (
                <ArticuloPage isAuth={getAuthData.isLoggedIn} {...props} />
              )}
            />
            <Route
              //exact
              path='/articulo/:id'
              render={(props) => (
                <ArticuloDetails isAuth={getAuthData.isLoggedIn} {...props} />
              )}
            />
            <Route exact path='/crear-articulo' component={ArticuloCrear} />
            <Route
              exact
              path='/editar-articulo/:id'
              component={ArticuloEditar}
            />
            <Route
              exact
              path='/ponencias'
              render={(props) => (
                <PonenciaPage isAuth={getAuthData.isLoggedIn} {...props} />
              )}
            />
            <Route exact path='/crear-ponencia' component={PonenciaCrear} />
            <Route
              exact
              path='/editar-ponencia/:id'
              component={PonenciaEditar}
            />
            <Route
              exact
              path='/cuentos'
              render={(props) => (
                <CuentoPage isAuth={getAuthData.isLoggedIn} {...props} />
              )}
            />
            <Route
              //exact
              path='/cuento/:id'
              render={(props) => (
                <CuentoDetails isAuth={getAuthData.isLoggedIn} {...props} />
              )}
            />
            <Route exact path='/crear-cuento' component={CuentoCrear} />
            <Route exact path='/editar-cuento/:id' component={CuentoEditar} />
            <Route
              exact
              path='/poesias'
              render={(props) => (
                <PoesiaPage isAuth={getAuthData.isLoggedIn} {...props} />
              )}
            />
            <Route
              //exact
              path='/poesía/:id'
              render={(props) => (
                <PoesiaDetails isAuth={getAuthData.isLoggedIn} {...props} />
              )}
            />
            <Route exact path='/crear-poesía' component={PoesiaCrear} />
            <Route exact path='/editar-poesía/:id' component={PoesiaEditar} />
            <Route
              exact
              path='/libros'
              render={(props) => (
                <LibroPage isAuth={getAuthData.isLoggedIn} {...props} />
              )}
            />
            <Route exact path='/crear-libro' component={LibroCrear} />
            <Route exact path='/editar-libro/:id' component={LibroEditar} />
            <Route exact path='/' component={IndexPage} />
            <Redirect to='/' />
          </UsuarioLayout>
          {/* <Route exact path='*' component={NotFoundPage} /> */}
        </Switch>
      );
    }
  }

  if (getErrorData) {
    if (getErrorData.isNetworkError) {
      routes = (
        <Switch>
          <Route exact path='/network-error' component={NetworkErrorPage} />
          <Redirect to='/network-error' />
        </Switch>
      );
    }
  }

  return <Fragment>{routes}</Fragment>;
};

export default App;
